import React from 'react';
import {
  DatePicker,
  Dialog,
  Layout,
  PhoneInput,
  Spacer,
  Text,
} from '@di-nxt/components';
import {t} from '../../../localization';
import {useNewMembers} from './hooks';
import {AddMemberProps} from './types';
import {ModalProps} from '../../../services';

const flexCol1 = 30;
const flexCol2 = 22;

export const AddMemberScreen: React.FC<ModalProps<AddMemberProps, boolean>> = ({
  teamId,
  callback,
}) => {
  // Viewmodel with new members
  const {
    team,
    newMembers,
    isValid,
    handleAddRow,
    handleSubmit,
    handleCancel,
    handlePhoneChanged,
    handleStartDateChanged,
  } = useNewMembers(teamId, callback);

  return (
    <Dialog
      size="Small"
      okButtonTitle={t('general.add')}
      cancelButtonTitle={t('general.cancel')}
      title={t('screens.members.addpeopledialog.title', {
        name: team?.name ?? '',
      })}
      okButtonDisabled={!isValid}
      hasCloseButton
      onCancelButton={handleCancel}
      onOkButton={handleSubmit}>
      <Layout vertical flex>
        <Spacer height="18" />
        {/* Column headers */}
        <Layout paddingBottom="18">
          <Layout flex={flexCol1}>
            <Text variant="inline_14_emphasis">
              {t('screens.members.addpeopledialog.columns.phone.header')}
            </Text>
          </Layout>
          <Spacer width="12" />
          <Layout flex={flexCol2}>
            <Text variant="inline_14_emphasis">
              {t('screens.members.addpeopledialog.columns.startdate.header')}
            </Text>
          </Layout>
        </Layout>

        {/* Pr new member input */}
        <Layout vertical>
          {newMembers.map((m, index) => (
            <Layout key={`m-${index}`} horizontal paddingBottom="20">
              <Layout flex={flexCol1}>
                <PhoneInput
                  onChange={numberInfo => handlePhoneChanged(index, numberInfo)}
                  initialCountryIso2="NO"
                  favouritesIso2={['NO', 'SE', 'FI']}
                />
              </Layout>
              <Spacer width="12" />
              <DatePicker
                flex={flexCol2}
                size="Default"
                selectedDate={newMembers[index].startDate}
                onDateChanged={date => handleStartDateChanged(index, date)}
              />
            </Layout>
          ))}
        </Layout>
        <Text variant="paragraph_14_emphasis" onPress={handleAddRow}>
          {t('screens.members.addpeopledialog.addmultiple')}
        </Text>
      </Layout>
    </Dialog>
  );
};
